import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

interface VideoProps {
  display: string;
}

export const StyledSection = styled(Section)`
  background: #ffffff !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h1`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 85%;
  letter-spacing: -0.56px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;
  min-height: calc(28px * 0.85);

  ${media.md`
    font-size: 70px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -1.4px;
    min-height: calc(70px * 0.85);
  `}

  ${media.xl`
    font-size: 110px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -2.2px;
    min-height: calc(110px * 0.85);
  `}
`;

export const Text = styled.p`
  color: #67656e;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  text-align: center;
  margin: 0px;
  min-height: calc(16px * 1.35);

  ${media.md`
    font-size: 22px;
    font-weight: 500;
    line-height: 123%;
    letter-spacing: -0.48px;
    min-height: calc(22px * 1.23);
  `}

  ${media.md`
    font-size: 28px;
    font-weight: 500;
    line-height: 123%;
    letter-spacing: -0.48px;
    min-height: calc(28px * 1.23);
  `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 32px;
  margin: 24px 0px 0px;

  ${media.md`
    flex-direction: row;
    gap: 60px;
    margin: 40px 0px 0px;
  `}

  ${media.xl`
    gap: 120px;
    margin: 50px 0px 0px;
  `}

  iframe {
    border: none;
  }
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${media.md`
    width: calc(50% - 30px);
  `}

  ${media.xl`
    width: calc(50% - 60px);
  `}
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: auto;
  display: none;

  ${media.lg`
    width: auto;
    height: 650px;
    display: block;
  `}

  img {
    width: 100%;
    height: auto;

    ${media.lg`
      width: auto;
      height: 650px;
    `}
  }
`;

export const Video = styled.video<VideoProps>`
  display: ${props => props.display || 'block'};
  width: 80%;
  height: auto;

  ${media.lg`
    width: auto;
    height: 650px;
  `}
`;

export const ContentSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${media.md`
    width: calc(50% - 30px);
  `}

  ${media.xl`
    width: calc(50% - 60px);
  `}
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  background: #ffffff !important;
`;
